import request from '@/router/axios'
// 获取企业信息列表
export function fetchList(query) {
  return request({
    url: '/platformProject/',
    method: 'post',
    params: query
  })
}

// 获取企业信息列表
export function getProjectInfo(query) {
    return request({
      url: '/companyProject/getProjectInfo',
      method: 'post',
      params: query
    })
  }
// 获取员工信息列表
export function getWorkerInfo(query) {
  return request({
    url: '/platformCompany/userList',
    method: 'post',
    params: query
  })
}

// 取消项目
export function closeProject(query) {
  return request({
    url: '/platformCompany/cancelProject',
    method: 'post',
    params: query
  })
}

export function addObj(obj) {
  return request({
    url: '/platformUser/insert',
    method: 'post',
    params: obj
  })
}

export function getObj(obj) {
  return request({
    url: '/platformUser/info',
    method: 'post',
    params: obj
  })
}

//删除工程
export function deletOrder(obj) {
  return request({
    url: '/companyProject/delete',
    method: 'post',
    params: obj
  })
}

//查看进度
export function getProgInfo(obj) {
  return request({
    url: '/companyProject/getProjectLogs',
    method: 'post',
    params: obj
  })
}

export function delObj(id) {
  return request({
    url: '/admin/user/' + id,
    method: 'delete'
  })
}

export function putObj(obj) {
  return request({
    url: '/platformUser/update',
    method: 'post',
    params: obj
  })
}
export function selectState(obj) {
    return request({
      url: '/platformCompany/updateStatus',
      method: 'post',
      params: obj
    })
  }

// 获取所有角色
export function roleList(query) {
  return request({
    url: '/role/rolePage',
    method: 'post',
    params: query
  })
}

// 停用
export function stop(query) {
  return request({
    url: '/platformUser/updateStatus',
    method: 'post',
    params: query
  })
}

//拒绝结项
export function refuse(query) {
  return request({
    url: '/companyProject/refuseProjectFinish',
    method: 'post',
    params: query
  })
}

//同意结项
export function agree(query) {
  return request({
    url: '/companyProject/agreeProjectFinish',
    method: 'post',
    params: query
  })
}
//平台取消项目
export function cancelproject(query) {
  return request({
    url: '/v2/companyProject/cancelProject',
    method: 'post',
    params: query
  })
}

//验收报告
export function getReport(query) {
  return request({
    url: '/projectExecution/getAcceptanceReport',
    method: 'post',
    params: query
  })
}

//产看日志信息
export function getFeedbacks(query) {
  return request({
    url: '/projectExecution/getFeedbacks',
    method: 'post',
    params: query
  })
}

//评论信息
export function getComment(query) {
  return request({
    url: '/v2/projectComment/getCommentList',
    method: 'post',
    params: query
  })
}

//评论信息新接口
export function getComment2(query) {
  return request({
    url: '/v2/projectComment/getCommentList2',
    method: 'post',
    params: query
  })
}
//获取项目相关人和工人数据
export function getProjectAllUser(query){
  return request({
    url: '/companyProject/getProjectAllUser',
    method: 'post',
    params: query
  })
}

//提交评论信息
export function insertComment(query) {
  return request({
    url: '/v2/projectComment/insert',
    method: 'post',
    params: query
  })
}
//提交评论信息 新接口
export function insertComment2(query) {
  return request({
    url: '/v2/projectComment/insert2',
    method: 'post',
    params: query
  })
}
//提交客诉原因
export function closeFeedback(query) {
  return request({
    url: '/projectExecution/closeFeedback',
    method: 'post',
    params: query
  })
}

export function getrecordinfo(query) {
  return request({
    url: '/projectExecution/getFeedbackInfo',
    method: 'post',
    params: query
  })
}

//添加日志
export function insertrecord(query) {
  return request({
    url: '/projectExecution/addFeedback',
    method: 'post',
    params: query
  })
}


//项目反馈月份查询
export function Feedbackmonth(query) {
  return request({
    url: '/projectExecution/getAllMonthProjectFeedback',
    method: 'post',
    params: query
  })
}

//项目反馈查询
export function FeedbackOneYear(query) {
  return request({
    url: '/projectExecution/getCompanyProjectsOneYear',
    method: 'post',
    params: query
  })
}

//查询反馈数据
export function allfeedback(query) {
  return request({
    url: '/projectExecution/getFeedbackManager',
    method: 'post',
    params: query
  })
}

//导出
export function impotdata(query) {
  return request({
    url: '/projectExecution/importProjectFeedbacks',
    method: 'post',
    params: query
  })
}

//更新表格数据
export function updateWorkTypes(query) {
  return request({
    url: '/companyProject/updateWorkTypes',
    method: 'post',
    params: query
  })
}

//提交修改联系人数据
export function updateAddressContact(query) {
  return request({
    url: '/companyProject/updateAddressContact',
    method: 'post',
    params: query
  })
}

//提交 修改协作联系人数据
export function updateRelevantContacts(query) {
  return request({
    url: '/companyProject/updateRelevantContacts',
    method: 'post',
    params: query
  })
}

//提交备注数据
export function updateDescribe(query) {
  return request({
    url: '/companyProject/updateDescribe',
    method: 'post',
    params: query
  })
}

//更新发布方式
export function updateProjectChannel(query) {
  return request({
    url: '/companyProject/updateProjectChannel',
    method: 'post',
    params: query
  })
}

//更新附件
export function updateFilePaths(query) {
  return request({
    url: '/companyProject/updateFilePaths',
    method: 'post',
    params: query
  })
}
